import { render, staticRenderFns } from "./GoToResource.vue?vue&type=template&id=6ecad219&scoped=true&"
import script from "./GoToResource.vue?vue&type=script&lang=js&"
export * from "./GoToResource.vue?vue&type=script&lang=js&"
import style0 from "./GoToResource.vue?vue&type=style&index=0&id=6ecad219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecad219",
  null
  
)

export default component.exports